import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';

const NotFound = () => <Result status={404} title={404} subTitle='La página que estabas buscando no existe.' extra={<Link to="/"><Button type="primary">Volver</Button></Link>} />

export default NotFound;
